/**
 * Diary Quiz Set 선택 드롭다운
 * ComponentOptionsEditor에서 assignment 타입일 때 사용
 */
import { useQuery } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { getDiaryQuizSets } from '@/api/diaryQuizSet'

interface DiaryQuizSetSelectorProps {
  value?: number
  onChange: (setId: number | undefined) => void
}

export const DiaryQuizSetSelector: React.FC<DiaryQuizSetSelectorProps> = ({
  value,
  onChange
}) => {
  const { data: sets, isLoading } = useQuery({
    queryKey: ['diary-quiz-sets'],
    queryFn: getDiaryQuizSets
  })

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-400">
        <Loader2 className="w-4 h-4 animate-spin" />
        로딩 중...
      </div>
    )
  }

  return (
    <div>
      <label className="block text-sm text-gray-700 mb-1">생각 정리하기 퀴즈 세트</label>
      <select
        value={value ?? ''}
        onChange={(e) => {
          const v = e.target.value
          onChange(v ? parseInt(v) : undefined)
        }}
        className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">선택 안 함</option>
        {sets?.map((set) => (
          <option key={set.id} value={set.id}>
            {set.name} ({set.itemCount}문제)
          </option>
        ))}
      </select>
      <span className="text-xs text-gray-500">
        클래스 내 모든 레슨이 동일한 퀴즈 세트를 사용합니다
      </span>
    </div>
  )
}
